import { useContext } from 'react'

import { EDITOR_TOOLS } from '@editor/config/constants'
import { EditorContext } from '@editor/contexts/Editor'
import { CanvasConfig } from '@editor/interfaces/editor'
import { focusCamera } from '@editor/services/Editor'
import { useAppDispatch } from '@editor/store/app'
import mixpanel from 'mixpanel-browser'
import { Vector3 } from 'three'

import { setTarget } from '../store'

export default function useMainCanvas(): CanvasConfig {
  // Context
  const { selectedTool, cameraRef, arcballControlsRef } = useContext(EditorContext)

  // Store
  const dispatch = useAppDispatch()

  // Derived
  const isToolSelected = selectedTool === EDITOR_TOOLS.FOCUS

  return {
    events: {
      onRawMouseUp: (event, pcdPoint, solidMeshPoint) => {
        const point = pcdPoint || solidMeshPoint
        if (!point || !arcballControlsRef.current || !cameraRef.current) return

        // Possible action to trigger
        // - Mouse middle click at anytime, with any tool
        if (event.button === 1) {
          focusCamera(arcballControlsRef.current, cameraRef.current, new Vector3(...point), Infinity)
          dispatch(setTarget(point))

          mixpanel.track('Camera Focus', {
            Trigger: 'Middle Click (Any Tool)',
          })
        }
      },
      onMouseUp: (event, pcdPoint, solidMeshPoint, { isDoubleClicked }) => {
        const points = pcdPoint || solidMeshPoint
        if (!points || !arcballControlsRef.current || !cameraRef.current) return

        // Possible action to trigger
        // - Double click on the same point with only the MOVE tool
        // - FOCUS tool is selected
        if ((isDoubleClicked && selectedTool === EDITOR_TOOLS.MOVE) || isToolSelected) {
          focusCamera(arcballControlsRef.current, cameraRef.current, new Vector3(...points), Infinity)
          dispatch(setTarget(points))

          mixpanel.track('Camera Focus', {
            Trigger: isToolSelected ? 'Single Click (Focus Tool)' : 'Double Click (Select Tool)',
          })
        }
      },
    },
  }
}
